import React, { useState } from 'react';
import { CTAButton } from './CTAButton';
import { OrnamentDivider } from './SectionDivider';
import { LegalModal } from './LegalModal';
export function CloseSection() {
  const [legalOpen, setLegalOpen] = useState<'privacy' | 'terms' | null>(null);
  return <>
      {legalOpen && <LegalModal type={legalOpen} onClose={() => setLegalOpen(null)} data-id="element-59" />}

      <section className="w-full py-24 px-6 pt-[30px] pb-[30px]" style={{
      background: 'linear-gradient(160deg, var(--cream) 0%, var(--cream-dark) 100%)'
    }} aria-label="Cierre emocional" data-id="element-60">
        <div className="max-w-3xl mx-auto text-center" data-id="element-61">
          <OrnamentDivider data-id="element-62" />

          <div className="mb-12 flex flex-col gap-6 mt-[10px]" data-id="element-63">
            <h2 className="text-4xl md:text-5xl font-bold" style={{
            color: 'var(--brown)',
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-64">
              Una Última Palabra
            </h2>

            <div className="flex flex-col gap-5 text-left" data-id="element-65">
              <p className="text-lg leading-relaxed" style={{
              color: 'var(--brown-light)',
              lineHeight: '1.9'
            }} data-id="element-66">
                Hay alguien en este momento buscando en Google{' '}
                <em data-id="element-67">"postres sin gluten que no sepan a cartón."</em>
              </p>
              <p className="text-lg leading-relaxed" style={{
              color: 'var(--brown-light)',
              lineHeight: '1.9'
            }} data-id="element-68">
                Hay una mamá que mañana tiene que llevar algo al cumpleaños del
                colegio y no sabe qué hacer.
              </p>
              <p className="text-lg leading-relaxed" style={{
              color: 'var(--brown-light)',
              lineHeight: '1.9'
            }} data-id="element-69">
                Hay una mujer que lleva años sin comer pastel en su propia
                familia porque nada de lo que hace queda bien.
              </p>
              <p className="text-lg leading-relaxed" style={{
              color: 'var(--brown-light)',
              lineHeight: '1.9'
            }} data-id="element-70">
                Hay un hombre al que su médico le prohibió el azúcar y que desde
                ese día siente que las celebraciones ya no son para él.
              </p>
            </div>

            <div className="rounded-2xl p-8 my-4" style={{
            background: 'var(--brown)'
          }} data-id="element-71">
              <p className="text-xl leading-relaxed mb-4" style={{
              color: 'var(--cream)',
              lineHeight: '1.85'
            }} data-id="element-72">
                Este libro es para todos ellos.
              </p>
              <p className="text-xl font-bold italic" style={{
              color: 'var(--gold-light)',
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: '1.4rem'
            }} data-id="element-73">
                Y si llegaste hasta aquí, también es para ti.
              </p>
            </div>

            <p className="text-2xl font-bold text-center" style={{
            color: 'var(--brown)',
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-74">
              El placer de comer bien no debería ser un privilegio de quienes no
              tienen restricciones.
            </p>
            <p className="text-xl text-center" style={{
            color: 'var(--gold-dark)',
            fontFamily: 'Cormorant Garamond, serif',
            fontSize: '1.3rem',
            fontStyle: 'italic'
          }} data-id="element-75">
              Es un derecho de todos.
            </p>

            <p className="text-3xl font-bold text-center mt-4" style={{
            color: 'var(--brown)',
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-76">
              Tu Dulce Libertad comienza con un clic.
            </p>
          </div>

          <CTAButton text="QUIERO MI DULCE LIBERTAD - $6,39 USD" subtext="Acceso inmediato • Garantía 30 días • Pago 100% seguro" size="lg" data-id="element-77" />

          <OrnamentDivider className="mt-16" data-id="element-78" />

          {/* Footer */}
          <div className="mt-8 flex flex-col items-center gap-3" data-id="element-79">
            <p className="text-sm" style={{
            color: 'var(--text-muted)'
          }} data-id="element-80">
              © 2026 DULCE LIBERTAD — Método Repostería Zero. Todos los
              derechos reservados.
            </p>
            <div className="flex items-center gap-2 text-sm" data-id="element-81">
              <button onClick={() => setLegalOpen('privacy')} className="underline underline-offset-2 transition-opacity hover:opacity-70" style={{
              color: 'var(--brown-light)',
              background: 'none',
              border: 'none',
              cursor: 'pointer'
            }} data-id="element-82">
                Políticas de Privacidad
              </button>
              <span style={{
              color: 'var(--text-muted)'
            }} data-id="element-83">
                ·
              </span>
              <button onClick={() => setLegalOpen('terms')} className="underline underline-offset-2 transition-opacity hover:opacity-70" style={{
              color: 'var(--brown-light)',
              background: 'none',
              border: 'none',
              cursor: 'pointer'
            }} data-id="element-84">
                Términos de Uso
              </button>
            </div>
            <p className="text-xs max-w-xl text-center mt-2" style={{
            color: 'var(--text-muted)',
            lineHeight: '1.7'
          }} data-id="element-85">
              Este sitio no forma parte del sitio web de Facebook ni de Facebook
              Inc. Además, este sitio NO está respaldado por Facebook de ninguna
              manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
            </p>
          </div>
        </div>
      </section>
    </>;
}